import React, { useState, useCallback, Fragment } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../../styles/AppTheme';
import { FormControl, TextField } from '@material-ui/core';
import { AppButton } from '../../components/AppButton';

export const ReportFilterBar = (props) => {
  const [dateTs, setDateTs] = useState(props.dateTs);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    if (name === 'dateTs') setDateTs(value);
  }, []);

  const handleFilter = useCallback(() => {
    if (dateTs) {
      props.onFilter({ dateTs });
    }
  }, [dateTs]);

  return (
    <Fragment>
      <div className={css(Styles.container)}>
        <form autoComplete='off' className={css(Styles.form)}>
          <div className={css(Styles.filterContainer)}>
            <div className={css(Styles.containerItems)}>
              <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
                <TextField
                  name='dateTs'
                  placeholder='Date'
                  type='date'
                  onChange={handleChange}
                  value={dateTs}
                  InputLabelProps={{
                    shrink: false, // Prevent label from shrinking to the top
                  }}
                  InputProps={{
                    classes: {
                      underline: css(Styles.noUnderline, Styles.inputStyle),
                    },
                    endAdornment: (
                      <img className={css(Styles.calenderIcon)} src={require('../../../assets/icons/calendar-blue.svg')} />
                    ),
                    startAdornment: null, // Optionally remove any adornments
                  }}
                />
              </FormControl>
            </div>
            <div>
              <AppButton
                buttonStyle={Styles.button}
                onClick={handleFilter}
                buttonTextStyle={Styles.buttonTextStyle}
                buttonText={props.buttonLabel || 'Filter'}
              />
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

const Styles = StyleSheet.create({
  calenderIcon: {
    position: 'absolute',
    right: '0',
    background: '#fff',
    pointerEvents: 'none'
  },
  filterContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
    '@media (max-width: 1024px)': {
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      gap: '8px !important'
    }
  },
  containerItems: {
    flex: 1,
    background: '#fff',
    padding: '0 13px',
    borderRadius: '8px',
    height: '45px',
    maxWidth: 250
  },
  formControl: {
    marginTop: 8
  },
  inputStyle: {
    fontSize: 16,
    color: '#575757'
  },
  noUnderline: {
    '::before': {
      borderBottom: 'none',
    },
    '::hover::before': {
      borderBottom: 'none',
    },
    '::after': {
      borderBottom: 'none',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 8,
    marginTop: 16,
    maxWidth: AppTheme.viewPort,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxWidth: AppTheme.viewPort,
    padding: 0,
    width: '100%',
    borderRadius: 8,
    '@media (max-width: 320px)': {
      maxWidth: 300,
      paddingBottom: 15,
    },
  },
  button: {
    background: '#ffffff',
    color: AppTheme.primaryColor,
    backgroundColor: AppTheme.secondaryBg,
    display: 'inline-flex'
  },
  buttonTextStyle: {
    fontWeight: 550
  }
});

export default ReportFilterBar;



// WEBPACK FOOTER //
// ./src/common/components/charts/ReportFilterBar.js